import { RootActions } from 'types/state';
import { FETCH_FORM_SUCCESS } from '@redux/modules/api/actionTypes';

/**
 * As application breaks down each section with its own reducer, we know that
 * several are unique versus using the curry function. fetchFormSuccessSlice is
 * meant to be a helper function that is used for application section reducers
 * to update data.
 */
export const fetchFormSuccessSlice = (state: any, action: RootActions, sectionName: string) => {
  if (action.type === FETCH_FORM_SUCCESS) {
    const newState = {
      ...state,
    };
    Object.keys(action.payload.normalized).forEach((key) => {
      if (action.payload.normalized[key].sectionName === sectionName) {
        const section = action.payload.normalized[key];

        newState[section.subsectionName] = {
          ...action.payload.normalized[key].data,
        };
      }
    });

    return newState;
  }

  return state;
};
